import { render, staticRenderFns } from "./HeaderPromotion.vue?vue&type=template&id=e59bab1a&"
import script from "./HeaderPromotion.vue?vue&type=script&lang=ts&"
export * from "./HeaderPromotion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports